import * as approvalService from '@/services/approval-service'
import { resignationConfigService } from '@/services/v2/resignation-config-service'

const defaultApproval = {
  _id: null,
  vacation: false,
  dismissals: false,
  vacancy: false,
  createdByAdmin: false,
  client: null,
  createdBy: null,
  updatedBy: null
}

const state = {
  approval: defaultApproval
}

const getters = {}

const mutations = {
  SET_APPROVAL: (state, payload) => {
    state.approval = payload
  }
}

const actions = {
  async loadApproval({ commit, rootState }) {
    const client = rootState.user.userClient

    // Get approval data from both services in parallel
    const [approvalData, resignationConfig] = await Promise.all([
      approvalService.getApprovalsByClient(client),
      resignationConfigService.getResignationConfigByClient(client)
    ])

    const approval =
      approvalData.data && approvalData.data.length > 0
        ? approvalData.data[0]
        : defaultApproval

    // Add resignation config data to approval state if exists
    if (resignationConfig.data) {
      approval.dismissals =
        resignationConfig.data.requireApprovalForResignation
    }

    commit('SET_APPROVAL', approval)
  },

  clearApproval({ commit }) {
    const defApproval = {
      _id: null,
      vacation: false,
      dismissals: false,
      vacancy: false,
      createdByAdmin: false,
      client: null,
      createdBy: null,
      updatedBy: null
    }
    commit('SET_APPROVAL', defApproval)
  },

  save({ commit, rootState }, approval) {
    approval.client = rootState.user.userClient
    approvalService.saveApproval(approval).then(({ data }) => {
      commit('SET_APPROVAL', data)
      // Message.success(i18n.t('treinamentocadastrado'))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
